import axios from 'axios';
import {rawreq, req} from './axiosFun';

// 班级数据 列表
export const queryByPage = (params) => {
  return req("post", "/api/class/queryByPage", params)
};
// 班级数据 列表 - 班主任
export const queryBzrBjByPage = (params) => {
  return req("post", "/api/class/queryBzrBjByPage", params)
};

// 班级数据 新增
export const savaClass = (params) => {
  return req("post", "/api/class/savaClass", params)
};

// 班级数据 修改
export const updateClass = (params) => {
  return req("post", "/api/class/updateClass", params)
};

// 班级数据 删除
export const deleteClass = (params) => {
  return req("post", "/api/class/deleteClass", params)
};

// 班级数据 详情
export const queryClassDetail = (params) => {
  return req("post", "/api/class/queryClassDetail", params)
};

// 班级数据  获取二维码
export const generateQRCode = (params) => {
  return req("post", "/api/class/generateQRCode", params)
};
// 班级数据  判断是否需要选择 渠道
export const getPzByShare = (params) => {
  return req("get", "/api/common/getSystemSzByCode?code=sfxsqd", params)
};

// 查询个人签到信息
export const queryStudentSignList = (params) => {
  return req("post", "/api/class/queryStudentSignList", params)
};

// 班级id查询学员列表
export const queryStudentByClassId = (params) => {
  return req("post", "/api/class/queryStudentByClassId", params)
};
// 班级id查询学员列表 - 班主任
export const queryBzrStudentByClassId = (params) => {
  return req("post", "/api/class/queryBzrStudentByClassId", params)
};

// 换班 查询班组列表
export const changeClassList = (params) => {
  return req("post", "/api/class/changeClassList", params)
};


// 班主任 列表
export const getBzrList = (params) => {
  return req("post", "/api/class/queryBzrList", params)
};


/*
*  班级绑定课程
* */
// 绑定课程
export const bindCourse = (params) => {
  return rawreq("post", "/api/lesson/add", params)
};
// 绑定课程
export const queryCourseByClassId = (id) => {
  return req("get", "/api/lesson/queryByClassId?classId=" + id, {})
};
// 清空课程
export const delCourseByClassId = (id) => {
  return req("get", "/api/lesson/deleteByClassId?classId=" + id, {})
};

// 课程 签到记录
export const queryQdByLesson = (params) => {
  return req("post", "/api/lesson/queryQdByLesson", params)
};
// 课程 签退记录
export const queryQtByLesson = (params) => {
  return req("post", "/api/lesson/queryQtByLesson", params)
};

// 上传签到信息
export const editQdByLesson = (params) => {
  return req("post", "/api/lesson/editQdByLesson", params)
};
// 上传签退信息
export const editQtByLesson = (params) => {
  return req("post", "/api/lesson/editQtByLesson", params)
};




// WEBPACK FOOTER //
// ./src/api/classInfo.js